import { createElement, Fragment } from 'react';
import { coreExtensionData } from '@backstage/frontend-plugin-api';
import catalogFrontendPlugin, {
  CatalogIndexPage,
} from '@backstage/plugin-catalog/alpha';
import { UserListPicker } from '@backstage/plugin-catalog-react';
import { userCatalogColumns } from '../../components/catalog/UserCatalogColumns';
import { PersistedUserListFilterPage } from '../../components/userListFilter/persistedUserListFilter';

// PAT-1027: `/catalog` is the page of `@backstage/plugin-catalog/alpha`. Both
// overrides below keep the upstream extension (same id, so they replace it;
// path, route ref, title, icon, config and inputs unchanged) and only swap
// its loader.

// The upstream page passes no `columns`, so the User-kind full-name search of
// `userCatalogColumns` (PAT-914) needs the loader re-supplied. It renders the
// same component as upstream (`CatalogIndexPage` is the alpha page's
// `NfsDefaultCatalogPage`) with the same filters, pagination and export
// settings. Upstream also merges `catalog-export-config` extensions into the
// export settings; none is registered in this app, so the configured
// `exportSettings` are all there is. Port that merge if one is ever added.
export const catalogIndexPageOverride = catalogFrontendPlugin
  .getExtension('page:catalog')
  .override({
    factory(originalFactory, { inputs, config }) {
      return originalFactory({
        params: {
          loader: async () => (
            <CatalogIndexPage
              // Static children, so React asks for no keys.
              filters={createElement(
                Fragment,
                null,
                ...inputs.filters.map(filter =>
                  filter.get(coreExtensionData.reactElement),
                ),
              )}
              columns={userCatalogColumns}
              pagination={config.pagination}
              exportSettings={
                config.exportSettings?.enabled
                  ? config.exportSettings
                  : undefined
              }
            />
          ),
        },
      });
    },
  });

// The Owned / Starred / All picker is its own filter extension, whose
// `initialFilter` is static config. `PersistedUserListFilterPage` re-reads the
// choice stored by `UserListFilterPersister` on every mount, so the page
// starts on the filter the user picked last on `/catalog`, `/api-docs` or
// `/docs`. The configured `initialFilter` (default `owned`, as the legacy
// route) is the fallback when nothing valid is stored, and a
// `?filters[user]=` URL param still wins over both.
export const catalogUserListFilterOverride = catalogFrontendPlugin
  .getExtension('catalog-filter:catalog/list')
  .override({
    factory(originalFactory, { config }) {
      return originalFactory({
        params: {
          loader: async () => (
            <PersistedUserListFilterPage
              propName="initialFilter"
              defaultFilter={config.initialFilter}
            >
              <UserListPicker />
            </PersistedUserListFilterPage>
          ),
        },
      });
    },
  });
